import React, { useState } from "react";
import { Eye, EyeOff } from "lucide-react";

const PasswordInput = ({
    value,
    onChange,
    placeholder,
    className = "",
}) => {

    const [showPassword, setShowPassword] = useState(false);

    return (
        <div className="relative w-full">

            <input
                type={showPassword ? "text" : "password"}
                value={value}
                onChange={onChange}
                placeholder={placeholder}
                className={`${className} pr-12 box-border`}
            />

            <button
                type="button"
                onClick={() => setShowPassword(!showPassword)}
                className="absolute right-4 top-1/2 -translate-y-1/2 text-gray-500"
            >
                {showPassword ? (
                    <EyeOff size={20} />
                ) : (
                    <Eye size={20} />
                )}
            </button>

        </div>
    );
};

export default PasswordInput;